import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { useCallback } from "react";
import { BRAND_LIST_QUERY_KEY } from "../constants";
import { BrandService } from "../services/brand.service";

import { IBrand } from "@shared/lib/types";

const QUERY_OPTIONS = {
  queryKey: BRAND_LIST_QUERY_KEY,
  skipInvalidation: false,
};

export function useEditBrand(queryKey?: string[]) {
  const assignUserBrand = useCallback(
    ({ brandId, brand }: { brandId: string; brand: Partial<IBrand> }) =>
      BrandService.updateBrand(brand, brandId).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    []
  );

  const {
    mutate: update,
    isLoading: isUpdating,
    isSuccess: isUpdated,
    variables,
  } = useMutation({
    mutationFn: assignUserBrand,
    options: QUERY_OPTIONS,
    onSuccess: (c, _, { brandId }) => {
      c.invalidateQueries({ queryKey: [...BRAND_LIST_QUERY_KEY, brandId] });
      if (queryKey) {
        c.invalidateQueries({ queryKey: queryKey });
      }
    },
  });

  return {
    update,
    isUpdating,
    isUpdated,
    variables,
  };
}
